<template>
    <error-layout>
        <template #errorTitle>
            {{$t('title')}}
        </template>

        <template #errorSubtitle>
            {{$t('subtitle')}}
        </template>

        <template #errorMessage>
            {{$t('message')}}
        </template>
    </error-layout>
</template>

<script>
    import ErrorLayout from '@/views/shared/ErrorLayout.vue';

    export default {
        name: "AccessDenied",
        components: {
            'error-layout': ErrorLayout
        }
    };
</script>

<i18n>
    {
        "hr": {
            "title": "403",
            "subtitle": "Zabranjen pristup",
            "message": "Nemate pravo pristupa ovoj stranici. Kliknite na gumb za povratak na početnu stranicu."
        },
        "en": {
            "title": "403",
            "subtitle": "Access denied",
            "message": "You cannot access this page. Please return to the home page."
        }
    }
</i18n>
